import { createSharingLinkView } from './components/Link';
import showLinkContextMenu, { closeLinkContextMenu } from './components/LinkContextMenu';
import { displaySpinnerOverlay } from './components/SpinnerOverlay';
import getComposeLinkViewState from './selectors/getComposeLinkViewState';
import isContextMenuOpen from './selectors/isContextMenuOpen';
import './mutators';

// exported constants
export { LINK_CONTEXT_MENU, OWA_AUTO_LINKS_CLASSNAME } from './utils/constants';

// export public actions
export {
    addComposeLinkViewState,
    removeAllComposeLinkViewStates,
    previewSharePointDocumentLinkInSxS,
} from './actions/publicActions';

export {
    getComposeLinkViewState,
    createSharingLinkView,
    isContextMenuOpen,
    showLinkContextMenu,
    closeLinkContextMenu,
    displaySpinnerOverlay,
};
